export default __webpack_public_path__ + "static/media/hht2_ep15_timeline_01.1cca61f9.png";